/*!
 * @copyright
 * Copyright(c) 2018 SICK AG
 */
// tslint:disable:no-bitwise
// tslint:disable:no-unsafe-any
// tslint:disable: no-any

/**
 * Decode a 64bit array
 * @param buf the array to decode
 */
function readInt64BE(buf) {
  const u8 = new Uint8Array(buf);
  const negate = (u8[0] & 0x80) === 0x80;

  if (negate) {
    let carry = 1;

    for (let i = 7; i >= 0; i--) {
      const v = (u8[i] ^ 0xff) + carry;
      u8[i] = v & 0xff;
      carry = v >> 8;
    }
  }

  const dv = new DataView(u8.buffer);
  const hi = dv.getUint32(0);
  const lo = dv.getUint32(4);
  return (hi * 4294967296 + lo) * (negate ? -1 : +1);
} //////////////////////////
// Begin interfaces
//////////////////////////
// tslint:disable-next-line: completed-docs


//////////////////////////
// Begin custom exeptions
//////////////////////////
// tslint:disable-next-line: completed-docs
export class IncompleteBufferError {
  constructor(message) {
    this.name = 'IncompleteBufferError';
    this.message = message || 'unable to decode';
  }

} // tslint:disable-next-line: completed-docs

export class DecoderNotFound {
  constructor(message) {
    this.name = 'DecoderNotFound';
    this.message = message;
  }

} // tslint:disable-next-line: completed-docs

export class UnsupportedDataTypeError {
  constructor(message) {
    this.name = 'UnsupportedDataTypeError';
    this.message = message;
  }

}
/**
 * Decoder for MessagePack data-format
 */

export class MsgPackDecoder {
  constructor() {
    this.extDecoder = [];
  }

  static _getUTF8String(buffer, offset, length) {
    const utf16 = new ArrayBuffer(length * 2);
    const utf16View = new Uint16Array(utf16);

    for (let i = 0; i < length; ++i) {
      utf16View[i] = buffer.getUint8(offset + i);
    }

    return String.fromCharCode.apply(null, utf16View);
  }

  registerDecoder(type, decoder) {
    this.extDecoder[type] = decoder;
  }

  decode(buffer) {
    if (buffer == null) {
      throw new IncompleteBufferError('The buffer cannot be null or undefined');
    }

    if (buffer.byteLength === 0) {
      return {};
    } // if result returns a null the buffer was incomplete


    const result = this._tryDecode(new DataView(buffer), 0);

    if (result) {
      return result.value;
    } else {
      throw new IncompleteBufferError();
    }
  }

  _tryDecode(buffer, offset) {
    const bufferLength = buffer.byteLength - offset;

    if (bufferLength <= 0) {
      return null;
    }

    const first = buffer.getUint8(offset);
    let length;
    let result = 0;
    let type;

    if (!this._hasMinBufferSize(first, bufferLength)) {
      return null;
    }

    switch (first) {
      case 0xc0:
        // nil/null
        return this._buildDecodeResult(null, 1);

      case 0xc2:
        // false
        return this._buildDecodeResult(false, 1);

      case 0xc3:
        // true
        return this._buildDecodeResult(true, 1);

      case 0xcc:
        // uint8
        result = buffer.getUint8(offset + 1);
        return this._buildDecodeResult(result, 2);

      case 0xcd:
        // uint16
        result = buffer.getUint16(offset + 1);
        return this._buildDecodeResult(result, 3);

      case 0xce:
        // uint32
        result = buffer.getUint32(offset + 1);
        return this._buildDecodeResult(result, 5);

      case 0xcf:
        // uint64
        for (let bytePos = 7; bytePos >= 0; bytePos--) {
          result += buffer.getUint8(offset + bytePos + 1) * Math.pow(2, 8 * (7 - bytePos));
        }

        return this._buildDecodeResult(result, 9);

      case 0xd0:
        // int8
        result = buffer.getInt8(offset + 1);
        return this._buildDecodeResult(result, 2);

      case 0xd1:
        // int16
        result = buffer.getInt16(offset + 1);
        return this._buildDecodeResult(result, 3);

      case 0xd2:
        // int32
        result = buffer.getInt32(offset + 1);
        return this._buildDecodeResult(result, 5);

      case 0xd3:
        // int64
        result = readInt64BE(buffer.buffer.slice(offset + 1, offset + 9));
        return this._buildDecodeResult(result, 9);

      case 0xca:
        // float32
        result = buffer.getFloat32(offset + 1);
        return this._buildDecodeResult(result, 5);

      case 0xcb:
        // float64 / double
        result = buffer.getFloat64(offset + 1);
        return this._buildDecodeResult(result, 9);

      case 0xd9:
        // str8
        length = buffer.getUint8(offset + 1);
        return this._buildDecodeResult(MsgPackDecoder._getUTF8String(buffer, offset + 2, length), 2 + length);

      case 0xda:
        // str16
        length = buffer.getUint16(offset + 1);
        return this._buildDecodeResult(MsgPackDecoder._getUTF8String(buffer, offset + 3, length), 3 + length);

      case 0xdb:
        // str32
        length = buffer.getUint32(offset + 1);

        const strResult = MsgPackDecoder._getUTF8String(buffer, offset + 5, length);

        return this._buildDecodeResult(strResult, 5 + length);

      case 0xc4:
        // bin8
        length = buffer.getUint8(offset + 1);
        return this._buildDecodeResult(new DataView(buffer.buffer, offset + 2, length), 2 + length);

      case 0xc5:
        // bin16
        length = buffer.getUint16(offset + 1);
        return this._buildDecodeResult(new DataView(buffer.buffer, offset + 3, length), 3 + length);

      case 0xc6:
        // bin32
        length = buffer.getUint32(offset + 1);
        return this._buildDecodeResult(new DataView(buffer.buffer, offset + 5, length), 5 + length);

      case 0xdc:
        // array16
        length = buffer.getUint16(offset + 1);
        return this._decodeArray(buffer, offset, length, 3);

      case 0xdd:
        // array32
        length = buffer.getUint32(offset + 1);
        return this._decodeArray(buffer, offset, length, 5);

      case 0xde:
        // maps up to 2^16 elements - 2 bytes
        length = buffer.getUint16(offset + 1);
        return this._decodeMap(buffer, offset, length, 3);

      case 0xdf:
        throw new Error('map too big to decode in JS');

      case 0xd4:
        return this._decodeFixExt(buffer, offset, 1);

      case 0xd5:
        return this._decodeFixExt(buffer, offset, 2);

      case 0xd6:
        return this._decodeFixExt(buffer, offset, 4);

      case 0xd7:
        return this._decodeFixExt(buffer, offset, 8);

      case 0xd8:
        return this._decodeFixExt(buffer, offset, 16);

      case 0xc7:
        // ext8
        length = buffer.getUint8(offset + 1);
        type = buffer.getUint8(offset + 2);
        return this._decodeExt(buffer, offset, type, length, 3);

      case 0xc8:
        // ext16
        length = buffer.getUint16(offset + 1);
        type = buffer.getUint8(offset + 3);
        return this._decodeExt(buffer, offset, type, length, 4);

      case 0xc9:
        // ext32
        length = buffer.getUint32(offset + 1);
        type = buffer.getUint8(offset + 5);
        return this._decodeExt(buffer, offset, type, length, 6);

      default:
        break;
    } // tslint:disable:no-bitwise


    if ((first & 0xf0) === 0x90) {
      //  array with less than 15 elements
      length = first & 0x0f;
      return this._decodeArray(buffer, offset, length, 1);
    } else if ((first & 0xf0) === 0x80) {
      // map <
      length = first & 0x0f;
      return this._decodeMap(buffer, offset, length, 1);
    } else if ((first & 0xe0) === 0xa0) {
      // fixstr
      length = first & 0x1f;

      if (this._isValidDataSize(length, bufferLength, 1)) {
        return this._buildDecodeResult(MsgPackDecoder._getUTF8String(buffer, offset + 1, length), length + 1);
      } else {
        return null;
      }
    } else if (first >= 0xe0) {
      // 5 bits negative ints
      result = first - 0x100;
      return this._buildDecodeResult(result, 1);
    } else {
      //  (first < 0x80) { these are all available values for a byte
      // 7-bits positive ints
      return this._buildDecodeResult(first, 1);
    }
  }

  _hasMinBufferSize(first, length) {
    const size = this._getSize(first);

    if (size !== -1 && length < size) {
      return false;
    } else {
      return true;
    }
  }

  _isValidDataSize(dataLength, bufLength, headerLength) {
    return bufLength >= headerLength + dataLength;
  }

  _buildDecodeResult(value, bytesConsumed) {
    return {
      value,
      bytesConsumed
    };
  }

  _decodeArray(buffer, offset, length, headerLength) {
    const result = [];
    let totalBytesConsumed = 0;
    offset += headerLength;

    for (let i = 0; i < length; i++) {
      const decodeResult = this._tryDecode(buffer, offset);

      if (decodeResult) {
        result.push(decodeResult.value);
        offset += decodeResult.bytesConsumed;
        totalBytesConsumed += decodeResult.bytesConsumed;
      } else {
        return null;
      }
    }

    return this._buildDecodeResult(result, headerLength + totalBytesConsumed);
  }

  _decodeMap(buffer, offset, length, headerLength) {
    const result = {};
    let key;
    let totalBytesConsumed = 0;
    offset += headerLength;

    for (let i = 0; i < length; i++) {
      const keyResult = this._tryDecode(buffer, offset);

      if (keyResult) {
        offset += keyResult.bytesConsumed;

        const valueResult = this._tryDecode(buffer, offset);

        if (valueResult) {
          key = keyResult.value;
          result[key] = valueResult.value;
          offset += valueResult.bytesConsumed;
          totalBytesConsumed += keyResult.bytesConsumed + valueResult.bytesConsumed;
        } else {
          return null;
        }
      } else {
        return null;
      }
    }

    return this._buildDecodeResult(result, headerLength + totalBytesConsumed);
  }

  _decodeFixExt(buffer, offset, size) {
    const type = buffer.getInt8(offset + 1);
    return this._decodeExt(buffer, offset, type, size, 2);
  }

  _decodeExt(view, offset, type, size, headerSize) {
    const newOffset = offset + headerSize;

    if (this.extDecoder[type] == null) {
      throw new DecoderNotFound('Decoder ' + type + ' not found');
    }

    const newView = new DataView(view.buffer, newOffset, size);
    const value = this.extDecoder[type].decode(newView);
    return this._buildDecodeResult(value, headerSize + size);
  }

  _getSize(first) {
    switch (first) {
      case 0xc4:
        return 2;

      case 0xc5:
        return 3;

      case 0xc6:
        return 5;

      case 0xc7:
        return 3;

      case 0xc8:
        return 4;

      case 0xc9:
        return 6;

      case 0xca:
        return 5;

      case 0xcb:
        return 9;

      case 0xcc:
        return 2;

      case 0xcd:
        return 3;

      case 0xce:
        return 5;

      case 0xcf:
        return 9;

      case 0xd0:
        return 2;

      case 0xd1:
        return 3;

      case 0xd2:
        return 5;

      case 0xd3:
        return 9;

      case 0xd4:
        return 3;

      case 0xd5:
        return 4;

      case 0xd6:
        return 6;

      case 0xd7:
        return 10;

      case 0xd8:
        return 18;

      case 0xd9:
        return 2;

      case 0xda:
        return 3;

      case 0xdb:
        return 5;

      case 0xde:
        return 3;

      default:
        return -1;
    }
  }

}
//# sourceMappingURL=MsgPackDecoder.js.map